import { Message } from 'semantic-ui-react';

export const MaintenanceMessages = ({ error, success, onClearMessages }) => {
  if (!error && !success) return null;

  return (
    <>
      {error && (
        <Message 
          negative 
          onDismiss={onClearMessages}
          content={error}
          style={{ marginBottom: '1rem' }}
        />
      )}
      
      {success && (
        <Message 
          positive 
          onDismiss={onClearMessages}
          content={success}
          style={{ marginBottom: '1rem' }}
        />
      )}
    </>
  );
};

export default MaintenanceMessages;